export default "__VITE_ASSET__ba094054__"